import React, { useState } from 'react';
import { Spin } from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCheck, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import ProcessButton from '../buttons/ProcessButton';
import { otpIdentityApi, getMmmHhMmDate } from '../utils/ApiUtils';

const section4Str = "Your data is never sold to third parties.\nHit.Movie does not serve ads.\nYou can delete your data anytime.";
const text2Str = "You can delete your data anytime.\nJust click the red button below.";
const text3Str = "Once your ID data is deleted you will not be able to buy and watch movies. To get back on the platform you must undergo the verification process again.";

export default function StepFour(props) {
  
    const [loader, setLoader] = useState(false);
    const [message, setMessage] = useState(text3Str);
    const textColor = props.whiteColor, yellowColor = props.yellowColor, redColor = props.redColor, greenColor = props.greenColor;
  
    const deleteID = () => {
        console.log('delete ID called.');
        setLoader(true);
        otpIdentityApi(props.sessionValue, 'generate')
          .then(response => {
            console.log('delete identity response='+JSON.stringify(response));
            if(response.info&&response.info.otpstatus=='NOT_VERIFIED') {
              console.log('Identity deleted successfully.');
              props.deleteID();
            } else {
              console.log('Identity delete failed!');
              setMessage('Identity delete failed! Please try again.');
            }
        });
    }

    return (
      <div>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <FontAwesomeIcon icon={faUserCheck} style={{ color: greenColor, fontSize: 30, marginTop: 30 }} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
        margin: 30 }}>
            <div style={{ fontSize: 18, fontFamily: 'OpenSans-SemiBold', color: greenColor }}>
                ID VERIFICATION SUCCESSFUL
            </div>
            <div style={{ fontSize: 14, fontFamily: 'OpenSans-Regular', color: greenColor, lineHeight: 1.2,
            whiteSpace: 'break-spaces', textAlign: 'center' }}>
                on {getMmmHhMmDate(props.identityVerificationTime)}
            </div>
            <div style={{ fontSize: 14, fontFamily: 'OpenSans-Regular', color: yellowColor, lineHeight: 1.2,
            whiteSpace: 'break-spaces', textAlign: 'center', marginTop: 30 }}>
                {section4Str}
            </div>
            <div style={{ fontSize: 14, fontFamily: 'OpenSans-Regular', color: textColor, lineHeight: 1.2,
            whiteSpace: 'break-spaces', textAlign: 'center', marginTop: 20 }}>
                {text2Str}
            </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 60 }}>
            <ProcessButton text="Delete ID Data" bgColor={redColor} onClick={() => deleteID()} />
            <div onClick={()=> window.open("https://docs.hit.movie/identity-verification", "_blank")} style={{ position: 'absolute', marginLeft: 220, marginTop: 10, cursor: 'pointer' }}>
                <FontAwesomeIcon icon={faQuestionCircle} style={{ color: props.yellowColor, fontSize: 20 }} />
            </div>
        </div>
        <div style={{ fontSize: 12, fontFamily: 'OpenSans-Regular', color: redColor, lineHeight: 1.2,
            whiteSpace: 'break-spaces', textAlign: 'center', margin: 30, marginTop: 16 }}>
            {message}
        </div>
        { loader &&
            <div style={{ position: 'absolute', display: 'flex', justifyContent: 'center', alignItems: 'center',
            top: 0, left: 0, width: '100%', height: '100%', zIndex: 11, backgroundColor: 'rgba(10, 26, 42, 0.6)' }}>
                <Spin size='large' />
            </div>
        }
      </div>
    );
}